import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import OptionCustomFieldValue from "@mapmycustomers/shared/types/customField/OptionCustomFieldValue";

import useRowHeightUpdater from "@app/component/grid/util/hooks/useRowHeightUpdater";

import OptionTag from "./components/OptionTag";
import styles from "./MultiOptionCustomFieldCellRenderer.module.scss";

const MultiOptionCustomFieldCellRenderer: React.FC<ICellRendererParams> = ({
  api,
  column,
  node,
  value,
}) => {
  useRowHeightUpdater(node, api);

  if (!value || !(value as OptionCustomFieldValue).values.length) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  const optionValue = value as OptionCustomFieldValue;

  return (
    <div className={styles.container}>
      {optionValue.values
        .filter((optionId) => optionValue.optionMap.has(optionId))
        .map((optionId) => (
          <OptionTag
            fieldName={column.getColId()}
            key={optionId}
            label={optionValue.optionMap.get(optionId)!}
            value={optionId}
          />
        ))}
    </div>
  );
};

export default MultiOptionCustomFieldCellRenderer;
